import { useEffect } from 'react';
import axios from 'axios';

const CheckPlusSuccess = () => {

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const EncodeData = urlParams.get('EncodeData');
    console.log('✅ EncodeData:', EncodeData); // 디버깅용

    if (EncodeData) {
        axios.post('/commonapi/nice/success.do', new URLSearchParams({ EncodeData }), {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(res => {
            const data = res.data;
            window.opener?.postMessage(data, '*');
            window.close();
        })
        .catch(err => {
            alert('본인인증 처리 중 오류 발생');
            window.close();
        });
    }
  }, []);

  return (<div>본인인증 결과를 처리 중입니다...</div>);
}

export default CheckPlusSuccess;